var map = {
	"./arbeitssieg-im-pokal.md": 9952,
	"./auf-ins-viertelfinale.md": 9010,
	"./ausflug-zum-fcs-tischtennis.md": 5935,
	"./befreiungsschlag-am-samstag.md": 7419,
	"./der-nikolaus-beim-ttc-rehlingen.md": 5422,
	"./donnerschlag-am-donnerstag.md": 8970,
	"./dritter-platz-im-final-4-turnier.md": 2047,
	"./ein-dorf-spielt-tischtennis.md": 939,
	"./einladung-zur-mitgliederversammlung-06-04-25.md": 3339,
	"./erster-saisonsieg-im-hauseigenen-derby.md": 710,
	"./gemischte-gefühle-beider-herrenmannschaften.md": 176,
	"./heimspielzeit-ist-punktezeit.md": 6803,
	"./jugendaktion-am-13-09-2024.md": 8170,
	"./kantersieg-im-internen-duell.md": 7823,
	"./klare-niederlage-gegen-die-ttg-fremersdorf-gerlfangen-2.md": 3322,
	"./niederlage-in-hülzweiler.md": 6372,
	"./rückblick-auf-die-maiwanderung-vom-01-05-2025.md": 8573,
	"./saisonabschluss-der-jugend.md": 4805,
	"./sonstige-spielberichte-der-letzten-woche.md": 2771,
	"./spielbericht-der-letzten-woche-27-01-02-02-25.md": 1338,
	"./spielberichte-der-letzten-woche-1.md": 6246,
	"./spielberichte-der-letzten-woche-10-11-17-11-24.md": 1462,
	"./spielberichte-der-letzten-woche-17-11-24-11-24.md": 9849,
	"./spielberichte-der-letzten-woche-25-11-30-11-24.md": 2551,
	"./spielberichte-der-letzten-woche-30-09-06-10-24.md": 4456,
	"./spielberichte-der-letzten-woche-saisonbilanz.md": 3153,
	"./spielberichte-der-letzten-woche.md": 9192,
	"./spielberichte-der-vergangenen-woche-02-02-25-09-02-25.md": 271,
	"./spielberichte-der-vergangenen-woche-02-03-09-03-25.md": 1044,
	"./spielberichte-der-vergangenen-woche-02-11-09-11-24-senioren.md": 9299,
	"./spielberichte-der-vergangenen-woche-09-02-2025-16-02-2025.md": 1577,
	"./spielberichte-der-vergangenen-woche-09-03-25-16-03-25.md": 8351,
	"./spielberichte-der-vergangenen-woche-16-03-23-03-25.md": 579,
	"./spielberichte-der-vergangenen-woche-23-03-30-03-25.md": 2193,
	"./spielberichte-der-vergangenen-woche-31-03-01-04-25.md": 8195,
	"./spielberichte-der-vergangenen-woche-senioren-2.md": 3530,
	"./spielberichte-der-vergangenen-woche.md": 2371,
	"./trainingspause-am-29-04-25-beendet.md": 643,
	"./trainingspause-in-den-osterferien.md": 9768,
	"./trainingszeiten-des-ttc-rehlingen.md": 8399,
	"./ttc-rehlingen-beim-bouleturnier.md": 1256,
	"./ungefährdeter-sieg-im-derby.md": 892,
	"./vereinsmeisterschaften-der-jugendlichen.md": 949,
	"./weihnachtsfeier-des-ttc-rehlingen.md": 1545
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 6390;